export default __webpack_public_path__ + "static/media/Rahul.650c4a3c.jpeg";